export const neverSymbol = Symbol('never');

type Ok = never;
type NotOk = unknown;

export type CheckExpectedOutput<O, ExpectedO, T> = T | (O extends ExpectedO ? Ok : NotOk);
export type CheckUnexpectedOutput<O, UnexpectedO, T> = T | (O extends UnexpectedO ? NotOk : Ok);
